import { render, staticRenderFns } from "./CrmLeadImport.vue?vue&type=template&id=3418a1f2&scoped=true&"
import script from "./CrmLeadImport.vue?vue&type=script&lang=js&"
export * from "./CrmLeadImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3418a1f2",
  null
  
)

export default component.exports